import i18n from '@/i18n';
import { FormFieldDescriptor } from '@/features/common/helpers/scrollToError';

export const createShipmentFormFields: FormFieldDescriptor[] = [
  // Ship From
  {
    elementId: 'from-contact-name',
    name: i18n.t('labels.fullName') as string,
    priority: 1,
  },
  {
    elementId: 'from-phone',
    name: i18n.t('labels.phone') as string,
    priority: 2,
  },
  {
    elementId: 'from-address',
    name: i18n.t('labels.address') as string,
    priority: 3,
  },
  {
    elementId: 'from-country',
    name: i18n.t('labels.country') as string,
    priority: 4,
  },
  {
    elementId: 'from-postal-code',
    name: i18n.t('labels.postalCode') as string,
    priority: 5,
  },
  {
    elementId: 'from-city',
    name: i18n.t('labels.city') as string,
    priority: 6,
  },
  {
    elementId: 'from-province',
    name: i18n.t('labels.provinceState') as string,
    priority: 7,
  },
  {
    elementId: 'from-email',
    name: i18n.t('labels.eMail') as string,
    priority: 8,
  },
  // Ship To
  {
    elementId: 'to-contact-name',
    name: i18n.t('labels.fullName') as string,
    priority: 9,
  },
  {
    elementId: 'to-phone',
    name: i18n.t('labels.phone') as string,
    priority: 10,
  },
  {
    elementId: 'to-address',
    name: i18n.t('labels.address') as string,
    priority: 11,
  },
  {
    elementId: 'to-country',
    name: i18n.t('labels.country') as string,
    priority: 12,
  },
  {
    elementId: 'to-postal-code',
    name: i18n.t('labels.postalCode') as string,
    priority: 13,
  },
  {
    elementId: 'to-city',
    name: i18n.t('labels.city') as string,
    priority: 14,
  },
  {
    elementId: 'to-province',
    name: i18n.t('labels.provinceState') as string,
    priority: 15,
  },
  {
    elementId: 'to-email',
    name: i18n.t('labels.eMail') as string,
    priority: 16,
  },
  // Sold To
  {
    elementId: 'soldto-contact-name',
    name: i18n.t('labels.fullName') as string,
    priority: 17,
  },
  {
    elementId: 'soldto-phone',
    name: i18n.t('labels.phone') as string,
    priority: 18,
  },
  {
    elementId: 'soldto-address',
    name: i18n.t('labels.address') as string,
    priority: 19,
  },
  {
    elementId: 'soldto-postal-code',
    name: i18n.t('labels.postalCode') as string,
    priority: 20,
  },
  {
    elementId: 'soldto-city',
    name: i18n.t('labels.city') as string,
    priority: 21,
  },
  {
    elementId: 'soldto-province',
    name: i18n.t('labels.provinceState') as string,
    priority: 22,
  },
  // Package (IDs already defined on AddPackageInputs)
  {
    elementId: 'package-type-add-package',
    name: 'Package Type',
    priority: 23,
  },
  {
    elementId: 'package-weight-add-package',
    name: 'Package Weight',
    priority: 24,
  },
  {
    elementId: 'weight-units-add-package',
    name: 'Weight Units',
    priority: 25,
  },
  {
    elementId: 'dimension-length-add-package',
    name: 'Length',
    priority: 26,
  },
  {
    elementId: 'dimension-width-add-package',
    name: 'Width',
    priority: 27,
  },
  {
    elementId: 'dimension-height-add-package',
    name: 'Height',
    priority: 28,
  },
  {
    elementId: 'dimension-units-add-package',
    name: 'Units',
    priority: 29,
  },
  {
    elementId: 'insurance-add-package',
    name: 'Insurance',
    priority: 30,
  },
  // Extras
  {
    elementId: 'signature-options-add-package',
    name: 'Signature Option',
    priority: 31,
  },
  {
    elementId: 'reference',
    name: 'Reference',
    priority: 32,
  },
];
